// src/components/GameCard.js
import React from 'react';
import './GameCard.css';

const GameCard = ({ title, image }) => {
    return (
        <div className="game-card">
            <img src={image} alt={title} className="game-image"/>
            <h3>{title}</h3>
        </div>
    );
};

export default GameCard;
